import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M4.756 9a3.37 3.37 0 0 1 .119-.125A2.892 2.892 0 0 1 7 8h4V6H7c-1.383 0-2.562.487-3.537 1.462-.466.466-.82.979-1.064 1.538h2.357ZM13 14v2h4c1.383 0 2.563-.488 3.538-1.463C21.513 13.562 22 12.383 22 11s-.487-2.563-1.462-3.538C19.563 6.487 18.383 6 17 6h-4v2h4a2.89 2.89 0 0 1 2.125.875c.583.584.875 1.291.875 2.125 0 .834-.292 1.541-.875 2.125A2.892 2.892 0 0 1 17 14h-4Zm-8 5v-3H2v-2h3v-3h2v3h3v2H7v3H5Zm11-9h-6v2h6v-2Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }